module.exports = __webpack_public_path__ + "d75077beb18cd82c8512b0563ff4a4ac.pdf";